import { Divider } from '@chilipiper/design-system'
import React from 'react'
import { BackToTemplates } from './BackToTemplates'
import { BookWithAssignee } from './BookWithAssignee'
import { StyledHeaderContainer } from './styles'
import './book-with.css'

interface Props {
  assigneeId?: string
  assigneeName?: string
  hideAssignee?: boolean
  hideBack?: boolean
  hideLogo?: boolean
  isQueue: boolean
  isReschedule?: boolean
  meetingApprovalFlow?: boolean
  onBack?: () => void
  showBack?: boolean
  templateName?: string
}

export const BookWithHeader = ({
  onBack,
  hideBack,
  hideLogo = false,
  isReschedule,
  templateName,
  assigneeId,
  assigneeName,
  showBack,
  isQueue,
  meetingApprovalFlow,
  hideAssignee,
}: Props) => {
  return (
    <StyledHeaderContainer
      w='100%'
      flexDirection='column'
      className='fabe-book-with-holder-wrapper'
    >
      <div data-chili-css='page-header' className='fabe-book-with-holder'>
        {showBack && templateName !== undefined && <BackToTemplates templateName={templateName} />}
        <BookWithAssignee
          isQueue={isQueue}
          hideBack={hideBack}
          hideAssignee={hideAssignee}
          onBack={onBack}
          assigneeId={assigneeId}
          isReschedule={isReschedule}
          isMeetingApprovalFlow={meetingApprovalFlow}
          assigneeName={assigneeName}
          hideLogo={hideLogo}
        />
      </div>
      <Divider display={['block', 'none']} />
    </StyledHeaderContainer>
  )
}
